import React from 'react'

export const Dashboard = () => (
  <section>
    <h2>Dashboard</h2>
  </section>
);
